import styled from 'styled-components';
import { Stack, Typography } from '@mui/material';
import Chip from '../Chip';

const ChangesList = styled(Stack)`
  border-radius: 8px;
  border: ${({ theme }) => `1px solid ${theme.palette.common.gray}`};
  background-color: ${({ theme }) => theme.palette.common.gray3};
`;

const Item = styled(Stack)`
  padding: 14px;

  &:not(:last-of-type) {
    border-bottom: ${({ theme }) => `1px solid ${theme.palette.common.gray}`};
  }
`;

type Props = {
  displayName: string;
  description: string | undefined;
};

const SchemaChangesList = ({ displayName, description }: Props) => (
  <ChangesList>
    <Item>
      <Typography sx={{ fontSize: '13px', color: 'common.gray2' }}>
        Schema change
      </Typography>
    </Item>
    <Item>
      <Stack
        direction="row"
        sx={{
          justifyContent: 'space-between',
          gap: 2,
        }}
      >
        <Typography sx={{ fontSize: '13px', whiteSpace: 'pre-wrap' }}>
          {description}
        </Typography>
        <Chip label={displayName} color="error" />
      </Stack>
    </Item>
  </ChangesList>
);

export default SchemaChangesList;
